import { Navigate, useLocation } from 'react-router-dom'

export default function RedirectToSites() {
  const location = useLocation()
  const newPath = location.pathname.replace('/customers', '/sites')
  return <Navigate replace to={newPath} />
}
